// import { Jute } from "../../..";
export class TestClock {
    private _currentTime = 0;
    private _paused = false;
    private _clockId?: string;
    public timeSteps;
    public finalTime;
    private _reqAnFrameHasRun = false;
    private _halfTimeCallbackHasRun?: boolean = false;
    private _onHalfTime?: () => any;
    constructor(finalTime: number, timeSteps: number, clockId?: string) {
        this.finalTime = finalTime;
        this.timeSteps = timeSteps;
        this._clockId = clockId;
    }

    pause = (): void => { this._paused = true };
    resume = (): void => { 
        this._paused = false 
        this._halfTimeCallbackHasRun = false;
    };
    start = (): void => { 
        this._currentTime = 0;
        this._reqAnFrameHasRun = false;
        this._halfTimeCallbackHasRun = false;
    };
    stop = (): void => { this._currentTime = 0 };

    requestAnimationFrame = (fn: FrameRequestCallback): number => {
        return window.requestAnimationFrame(() => {  
            if (!this._reqAnFrameHasRun) {
                this._reqAnFrameHasRun = true;
                this._paused = true;
                console.log(`transition_start_${this._clockId}`)
            }  
        
            if (!this._paused) {
                this._currentTime += this.timeSteps
                // Jute.testTimeChange(this._currentTime)
            }
            if (this._currentTime !== Math.floor(this.finalTime / 2)) {
                this._halfTimeCallbackHasRun = false;
            }

            if ((!this._halfTimeCallbackHasRun && (this._currentTime === Math.floor(this.finalTime / 2)) || this.finalTime === 0)) {
                this._paused = true;
                this._halfTimeCallbackHasRun = true;
                console.log(`transition_half_time_${this._clockId}`)
                this._onHalfTime?.()
            }
            fn(this._currentTime);
        })
    }

    getElapsedTime = (): number => {
        return this._currentTime / 1000;
    }

    onHalfTime = (cb: () => any): void => {
        this._onHalfTime = cb;
    }

}
